@if (loading()) {
  <app-spinner [black]="true"></app-spinner>
} @else if (subscriptionDetails(); as details) {
  <div class="sensor-header">
    <i nz-icon nzType="icons:subscription" class="sensor-icon svg-icon"></i>
    <h2>{{ i18n.langString("subscription_details") }}</h2>
  </div>

  <div class="additionalInformation">
    <nz-collapse [nzBordered]="false" [nzExpandIconPosition]="'end'">
      <nz-collapse-panel
        #sensorSub
        [nzShowArrow]="false"
        [nzHeader]="panelheader"
        [nzExtra]="collapseIcon"
        [nzActive]="false"
        [nzActive]="subscriptionPanelActive()"
        (nzActiveChange)="subscriptionPanelActive.set($event)"        
      >
        <ng-template #panelheader>
          <div class="collapse-header">
            <i nz-icon nzType="icons:info"></i>
            <span class="body-bold">
              {{ i18n.langString("current_subscription") }}
            </span>
          </div>
        </ng-template>

        <div class="parent-flex">
          <div class="subscription-heading">{{ i18n.langString("name") }}</div>
          <div class="subscription-name">{{ details.Subscriptionname }}</div>
        </div>

        <div class="parent-flex">
          <div class="subscription-heading">{{ i18n.langString("start") }}</div>
          <div class="subscription-name">
            {{ details.Subscriptionstartdate | date: dateFormatString() }}
          </div>
        </div>

        <div class="parent-flex">
          <div class="subscription-heading">{{ i18n.langString("end") }}</div>
          <div class="subscription-name">
            {{ details.Subscriptionenddate | date: dateFormatString() }}
          </div>
        </div>

        <ng-template #collapseIcon let-active>
          <i
            nz-icon
            [nzType]="subscriptionPanelActive() ? 'icons:minus' : 'icons:plus'"
          ></i>
        </ng-template>
      </nz-collapse-panel>
    </nz-collapse>
  </div>
}
